<template>
    <footer class="page-footer font-small bg-primary pt-4 text-white">

        <!-- Footer Links -->
        <div class="container-fluid text-center text-md-left">

            <!-- Grid row -->
            <div class="row">

                <!-- Grid column -->
                <div class="col-md-6 mt-md-0 mt-3">

                    <!-- Content -->
                    <h3>Rijn<span class="text-info">Gas</span></h3>
                    <p>{{$t('AppName')}} {{version}}</p>

                </div>

                <!--<div class="col-md-2 mt-md-0 mt-3">

                  
                    <h4 class="text-primary">...</h4>
                    <address>
                        <p>
                            De Marne 118<br>8701 MC Bolsward<br>
                            <a class="text-light" href="tel:+31515227027">0515-227027</a>
                            <br>
                            <a class="text-light" href="mailto:info@reinder.eu">info@reinder.eu</a>
                        </p>
                    </address>

                </div>-->
                <!-- Grid column -->

                <hr class="clearfix w-100 d-md-none pb-3">

                <!-- Grid column -->
                <!--<div class="col-md-3 mb-md-0 mb-3 text-center">

                    
                    <h4 class="text-md-left ml-3">Lid <span class="text-info">van</span></h4>

                    <b-row class="ml-0 justify-content-center text-md-left">
                        <div class="col-md-12">
                            <b-link href="https://dalti.nl/" class="text-light">
                                <span>{{$t('AppDescription')}}</span>
                            </b-link>
                        </div>
                        <div class="col-md-12">
                            <img src="https://reinder.eu/images/logo-dalti.jpg" alt="" class="img-thumbnail mt-2" />
                        </div>
                    </b-row>

                </div>-->

            </div>
            <!-- Grid row -->

        </div>
        <!-- Footer Links -->
        <!-- Copyright -->
        <!-- <div class="footer-copyright text-center bg-dark py-3 mt-2">
            2024 -
            <a href="https://reinder.eu/"> (C) REINDER.EU</a>
        </div> -->
        <!-- Copyright -->

    </footer>
</template>

<script>
    export default {
        name: "Footer",
        data() {
            return {
                version: process.env.VUE_APP_BUILD_VERSION,
            }
        }
    };
</script>
